module.exports = __webpack_public_path__ + "static/media/S1-27-Crottanox-cod47.2f6e888b.png";